module.exports = __webpack_public_path__ + "static/media/luftwaffe_j41_120x120.67f06a83.png";